import React, { Component } from 'react';
import {OrdinalFrame, ResponsiveOrdinalFrame} from "semiotic";

import colorMap from './colorMap'

let colorMap2 = {
    coal: "#282827", //Coal
    petroleum: "#7DAAA7", //Petroleum
    naturalGas: "#F9BD15", //Natural Gas
    otherGas: "#F04B31", //Other Gases
    nuclear: "#D385AA", //Nuclear
    hydroPumped: "#3F87A6", //Hydroelectric Pumped Storage
    hydroConventional: "#3F87A6", //Conventional Hydroelectric Power
    wood: "#B15A28", //Wood
    waste: "#938373", //Waste
    geothermal: "#426B45", //Geothermal
    solar: "#F58020", //Solar
    wind: "#8DC179", //Wind
};

class EmmissionsChart extends Component {

    render() {

        const emissionsData = [
            {type: "Coal – PC", color: colorMap['coal'], emissions: 820},
            {type: "Biomass – Cofiring with coal", color: colorMap['wood'], emissions: 740},
            {type: "Gas – combined cycle", color: colorMap['naturalGas'], emissions: 490},
            {type: "Biomass – Dedicated", color: colorMap['coal'], emissions: 230},
            {type: "CCS – Coal – PC", color: colorMap['coal'], emissions: 	220},
            {type: "CCS – Coal – IGCC", color: colorMap['coal'], emissions: 	200},
            {type: "CCS – Gas – combined cycle", color: colorMap['naturalGas'], emissions: 170},
            {type: "CCS – Coal – oxyfuel", color: colorMap['coal'], emissions: 	160},
            {type: "Solar PV – Utility scale", color: colorMap['solar'], emissions: 48},
            {type:  "Solar PV – rooftop", color: colorMap['solar'], emissions: 41},
            {type: "Geothermal", color: colorMap['geothermal'], emissions: 38},
            {type: "Concentrated solar power", color: colorMap['solar'], emissions: 27},
            {type: "Hydropower", color: colorMap['hydroConventional'], emissions: 24},
            {type: "Ocean (Tidal and wave)", color: colorMap['hydroConventional'], emissions: 17},
            {type: "Nuclear", color: colorMap['nuclear'], emissions: 12},
            {type:  "Wind Offshore", color: colorMap['wind'], emissions: 12},
            {type: "Wind Onshore", color: colorMap['wind'], emissions: 11}
        ];

        return (
                <ResponsiveOrdinalFrame
                    title={"IPCC Global Warming Potential of Electricity Sources"}
                    size={[700, 500]}
                    data={emissionsData}
                    responsiveWidth={true}
                    oAccessor={"type"}
                    rAccessor={d => d.emissions}
                    style={d => {return { fill: d.color}}}
                    type={"bar"}
                    oLabel={d => (
                        <text transform="translate(-15,0)rotate(45)">{d}</text>
                    )}
                    axis={{ orient: "left", label: "Median Life cycle CO2 equivalent (gCO2eq/kWh)", fontSize: 11}}
                    margin={{ left: 70, bottom: 170, right: 50, top: 55 }}
                    oPadding={5}
                />
        );
    }
}

export default EmmissionsChart;



// WEBPACK FOOTER //
// ./src/EmmissionsChart.jsx